import { render } from "./MyrtleBeachAbout.vue?vue&type=template&id=c3e8d234"
import script from "./MyrtleBeachAbout.vue?vue&type=script&lang=js"
export * from "./MyrtleBeachAbout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__